export const LOCATION_STATE_OFFER = 'Offer';
export const LOCATION_STATE_HOTEL = 'Hotel';
export const BOOKINGID_STORAGE_KEY = 'BID';
export const SMALL_GROUP = 'isSmallGroup';
export const MINI_GROUP = 'isMiniGroup';
export const SMALL_GROUP_STR_DE = 'kleingruppe';
export const MINI_GROUP_STR_DE = 'minigruppe';
export const NORMAL_GROUP = 'isNormalGroup';
export const SMALL_GROUP_IMG = '/img/groupSize/Logo_kleingruppe.svg';
export const MINI_GROUP_IMG = '/img/groupSize/Logo_minigruppe.svg';
export const SIGNUP_SOURCES = {
  DE: '/booking',
  AT: '/booking-at',
  CH: '/booking-ch'
};
export const DOI_KEYS = {
  DE: 'DoiTT',
  AT: 'DOIttAT',
  CH: 'DOIttCH'
};
